import type { PropsWithChildren } from 'react'
import { Title } from '@mantine/core'

import type { FormSectionProps } from './form-section.types'
import classes from './form-section.module.scss'

export function FormSection({
  title,
  children,
}: Readonly<PropsWithChildren<FormSectionProps>>) {
  return (
    <>
      <Title order={3} className={classes.SectionTitle}>
        {title}
      </Title>
      {children}
    </>
  )
}
